export default "__VITE_ASSET__aef75bd0__"